import React from "react"
import { useOutlet } from "react-router-dom"

export const Providers = () => {
  const outlet = useOutlet()
  return <>{outlet}</>
}
